var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createRef } from '@byted/light-render';
import { Group } from '../element';
import * as lodash from '../utils/lodash';
import { getLineStyle, getTextStyle, getShapeStyle } from '../utils/styleHelper';
var modelId = 0;
/**
 * base model
 */
var BaseModel = /** @class */ (function () {
    function BaseModel() {
        this.disposed = false;
        this.groupRef = createRef();
        this._eventListeners = {};
        modelId += 1;
        this.id = modelId.toString();
    }
    Object.defineProperty(BaseModel.prototype, "renderObj", {
        get: function () {
            return this.groupRef.current;
        },
        enumerable: true,
        configurable: true
    });
    // eslint-disable-next-line no-unused-vars
    BaseModel.prevProcessOption = function (option) {
        // void
    };
    BaseModel.prototype.getInitialState = function () {
        return null;
    };
    BaseModel.prototype.getKey = function (name) {
        return this.type + "-" + this.id + "-" + name;
    };
    BaseModel.prototype.getOption = function () {
        return this.option;
    };
    // eslint-disable-next-line no-unused-vars
    BaseModel.prototype.getThemeOption = function (option) {
        if (this.chart) {
            return lodash.get(this.chart.getTheme(), this.type);
        }
        return null;
    };
    BaseModel.prototype.setOption = function (partialOption) {
        this.option = lodash.merge(this.option, partialOption);
    };
    BaseModel.prototype.getState = function () {
        return this.state;
    };
    BaseModel.prototype.setState = function (state) {
        this.state = lodash.assign(this.state, state);
    };
    BaseModel.prototype.getTextStyle = function (option) {
        var defaultTextStyle = getTextStyle(this.chart.getOption().textStyle);
        var style = getTextStyle(option);
        if (this.chart.getOption().transition === false) {
            style.transitionProperty = 'none';
        }
        return __assign(__assign({}, defaultTextStyle), style);
    };
    BaseModel.prototype.getLineStyle = function (option) {
        var style = getLineStyle(option);
        if (this.chart.getOption().transition === false) {
            style.transitionProperty = 'none';
        }
        return style;
    };
    BaseModel.prototype.getShapeStyle = function (option) {
        var style = getShapeStyle(option);
        if (this.chart.getOption().transition === false) {
            style.transitionProperty = 'none';
        }
        return style;
    };
    BaseModel.prototype.handleUIEvent = function (event, item, detail) {
        var actionType = item + ":" + event.type;
        var action = __assign(__assign({}, detail), { type: actionType, mouse: event });
        this.chart.dispatchAction(action);
    };
    BaseModel.prototype.init = function () {
        // nothing
    };
    BaseModel.prototype.beforeRender = function () {
        // nothing
    };
    BaseModel.prototype.render = function () {
        return new Group({ key: this.id });
    };
    BaseModel.prototype.afterRender = function () {
        // nothing
    };
    // eslint-disable-next-line no-unused-vars
    BaseModel.prototype.update = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // nothing
    };
    BaseModel.prototype.updated = function () { };
    BaseModel.prototype.beforeDestroy = function () {
        // nothing
    };
    BaseModel.prototype.destroy = function () {
        this.beforeDestroy();
        this.removeAllEvents();
        this.groupRef.current = null;
        this.disposed = true;
    };
    BaseModel.prototype.getRenderObj = function () {
        return this.groupRef.current;
    };
    BaseModel.prototype.removeAllEvents = function () {
        var _this = this;
        var events = lodash.keys(this._eventListeners);
        events.forEach(function (event) { return _this.chart.off(event, _this._eventListeners[event]); });
        this._eventListeners = {};
    };
    /**
     * all the event will be removed auto when destroy
     * @param type event type
     * @param callback  event listener
     */
    BaseModel.prototype.registerEvent = function (type, callback) {
        if (!this._eventListeners[type]) {
            this._eventListeners[type] = callback;
            this.chart.on(type, callback);
        }
    };
    return BaseModel;
}());
export default BaseModel;
